// extracted by mini-css-extract-plugin
module.exports = {"container":"T-r9b _2s-6N","info":"_1J4tw","infoItem":"LKiO3","infoItemIcon":"_23hPt","infoItemText":"_3oK32"};